// extracted by mini-css-extract-plugin
export default {"list":"List-module__list__z8q6S","direction":"List-module__direction__j6Rpw","direction-column":"List-module__direction-column__NOtfm"};